export const TENANT_FEATURE = {
  PREMIER_MD_F2F_NOTES: "PREMIER_MD_F2F_NOTES",
  PREMIER_MD_CONSENT_FORMS: "PREMIER_MD_CONSENT_FORMS",
  PREMIER_MD_BRANDING: "PREMIER_MD_BRANDING",
} as const;

export type TenantFeature =
  (typeof TENANT_FEATURE)[keyof typeof TENANT_FEATURE];

const REALM_LIST_SEPARATOR = ",";

/** Env values are comma-separated realm lists, so one feature can serve several tenants. */
const parseRealmList = (raw: string | undefined): ReadonlySet<string> =>
  new Set(
    (raw ?? "")
      .split(REALM_LIST_SEPARATOR)
      .map((realm) => realm.trim())
      .filter(Boolean)
  );

const PREMIER_MD_REALMS = parseRealmList(import.meta.env.VITE_PREMIER_MD_REALM);
// The Premier MD logo belongs to the `premier` realm only, not every realm sharing its notes.
const PREMIER_MD_BRANDING_REALMS: ReadonlySet<string> = new Set(["premier"]);

/** Feature → realms that unlock it; realm names differ per environment, so they come from .env.* */
export const TENANT_FEATURE_REALMS: Readonly<
  Record<TenantFeature, ReadonlySet<string>>
> = {
  [TENANT_FEATURE.PREMIER_MD_F2F_NOTES]: PREMIER_MD_REALMS,
  [TENANT_FEATURE.PREMIER_MD_CONSENT_FORMS]: PREMIER_MD_REALMS,
  [TENANT_FEATURE.PREMIER_MD_BRANDING]: PREMIER_MD_BRANDING_REALMS,
};
